module.exports = __webpack_public_path__ + "img/send_goods_bottom_bg.5616f1a0.png";